import styled from 'styled-components';
import { Box } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { VimeoVideoPlayer } from '../../VimeoVideoPlayer/VimeoVideoPlayer';

const HOW_IT_WORKS_VIDEO_VIMEO_ID = '1190366886';
const VIDEO_WIDTH_PX = 710;
const VIDEO_HEIGHT_PX = 350;

const VideoWrapper = styled(Box)`
    width: auto;
    @media (min-width: 900px) and (max-width: 1050px) {
        width: 500px;
    }

    @media (min-width: 1050px) and (max-width: 1300px) {
        width: 600px;
    }

    ${mediaQuery.maximum('medium')} {
        width: 100%;
    }
`;

const VideoFrame = styled.div`
    position: relative;
    width: ${VIDEO_WIDTH_PX}px;
    height: ${VIDEO_HEIGHT_PX}px;

    ${mediaQuery.maximum('medium')} {
        width: 100%;
        max-width: ${VIDEO_WIDTH_PX}px;
        height: auto;
        aspect-ratio: ${VIDEO_WIDTH_PX} / ${VIDEO_HEIGHT_PX};
    }
`;

export default function HowItWorksVideo() {
    return (
        <VideoWrapper
            marginLeft={['none', 'none', '4bu', '4bu']}
            marginTop={['2bu', '2bu', 'none', 'none']}
        >
            <VideoFrame>
                <VimeoVideoPlayer
                    id={HOW_IT_WORKS_VIDEO_VIMEO_ID}
                    style={{
                        height: '100%',
                        left: 0,
                        position: 'absolute',
                        top: 0,
                        width: '100%',
                    }}
                />
            </VideoFrame>
        </VideoWrapper>
    );
}
